export const AlertDialogIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 88C53 80.8203 58.8203 75 66 75H334C341.18 75 347 80.8203 347 88V212C347 219.18 341.18 225 334 225H66C58.8203 225 53 219.18 53 212V88Z'
      fill='white'
    />
    <path
      d='M76 108C76 102.477 80.4772 98 86 98H242C247.523 98 252 102.477 252 108C252 113.523 247.523 118 242 118H86C80.4772 118 76 113.523 76 108Z'
      fill='#A0AEC0'
    />
    <path
      d='M76 146C76 142.686 78.6863 140 82 140H286C289.314 140 292 142.686 292 146C292 149.314 289.314 152 286 152H82C78.6863 152 76 149.314 76 146Z'
      fill='#CBD5E0'
    />
    <path
      d='M252 185C252 182.791 253.791 181 256 181H320C322.209 181 324 182.791 324 185V198C324 200.209 322.209 202 320 202H256C253.791 202 252 200.209 252 198V185Z'
      fill='#38B2AC'
    />
    <path
      d='M164 185C164 182.791 165.791 181 168 181H232C234.209 181 236 182.791 236 185V198C236 200.209 234.209 202 232 202H168C165.791 202 164 200.209 164 198V185Z'
      fill='#E2E8F0'
    />
  </svg>
)
